import { ref } from '@vue/composition-api';
import api from '@/api';

const dictionaries = {};
const requireModule = require.context('@/store/dictionaries/', true, /.*\.js$/);
requireModule.keys().forEach((fileName) => {
    const moduleName = fileName.replace(/(\.\/|\.js)/g, '');
    const module = requireModule(fileName).default;

    dictionaries[moduleName] = module;
});

const state = ref(dictionaries);
const getters = {
    config:                            state => state.config,
    apiVersion:                        state => state.apiVersion,
    currencies:                        state => state.currencies,
    countries:                         state => state.countries,
    categories:                        state => state.categories,

    getCurrency: state => name => {
        const currency = state.value.currencies.find((currency) => currency.name === name);
        return currency;
    },

    getCurrencySymbol: state => name => {
        const currency = state.value.currencies.find((currency) => currency.name === name);
        return (currency && currency.symbol) || name;
    },
};

export const getDictionaries = () => {
    return api.getDicts().then((response) => {
        state.value.paymentTerms = response.data.partners_payment_terms || [];
        state.value.trafficTypes = response.data.traffic_types || [];
        state.value.postbackEvents = response.data.postbacks_events_def || [];
        state.value.tagTypes = response.data.tags_type_def || [];
        state.value.content = (response.data.publisher_content || []).map((elem) => ({ name: elem }));
        state.value.offerCapTypes = Object.entries(response.data.offer_cap_types || {}).reduce((newArr, capType) => {
            newArr.push({ id: capType[0], name: capType[1] });
            return newArr;
        }, []) || [];
        state.value.paymentMethods = response.data.payment_request_payment_methods || [];
        state.value.paymentStatuses = response.data.payment_request_statuses || [];
        state.value.invoicesStatuses = response.data.invoices_statuses || [];

        state.value = { ...state.value };
    });
};

export const getCountriesDictionary = () => {
    return api.dicts.countries()
        .then(({ data }) => {
            state.value = { ...state.value, countries: data.data };
        });
};

export const getCategoriesDictionary = () => {
    return api.dicts.categories()
        .then(({ data }) => {
            state.value = { ...state.value, categories: data.data };
        });
};

export const getApprovalStatuses = () => {
    return api.dicts.approvalStatusesList().then(({ data }) => {
        state.value = { ...state.value, approvalStatuses: data.data };
    });
};

export default {
    getters,
    state,
};
